import React, { createContext, useReducer, useMemo } from 'react';
import PropTypes from 'prop-types';

import reducer from './Reducer';
import actions from './Actions';

const initialState = {
  user: null,
};

const context = createContext();

export function ContextProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  const value = useMemo(() => ({
    state, dispatch, actions,
  }), [state, dispatch, actions]);

  return (
    <context.Provider value={value}>
      {children}
    </context.Provider>
  );
}

ContextProvider.propTypes = {
  children: PropTypes.element.isRequired,
};

export const useContext = () => React.useContext(context);
